<template>
  <div class="mobile-topbar" v-if="isMobile">
    <a href="/index" class="logo">
      <img :src="staticUrl+'office/xzdzm/images/logo.png'" alt>
    </a>
    <a :class="{ active: 'index'=== currentActive }" @click="addClass('index')">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;首页</a>
    <a :class="{ active: 'game'=== currentActive }" @click="addClass('game')">游戏介绍</a>
  </div>
  <div class="topbar" v-else>
      <div class="left">
        <a href="/index" class="logo">
          <img :src="staticUrl+'office/xzdzm/images/logo.png'" alt>
        </a>
        <a :class="{ active: 'index'=== currentActive }" @click="addClass('index')">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;首页</a>
        <a :class="{ active: 'game'=== currentActive }" @click="addClass('game')">游戏介绍</a>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'topBar',
  data () {
    return {
      currentActive: 'index',
      queryParam: {}
    }
  },
  computed:{
    ...mapGetters(['isMobile','staticUrl']),
  },
  created () {
    var query = window.location.pathname
    if (query.length > 0) {
      var vars = query.split('/')
      if (vars[1].length === 0) {
        this.currentActive = 'index'
      }else{
        this.currentActive = vars[1]
      }
    }
  },
  methods: {
    addClass (index) {
      this.currentActive = index
      this.$router.push({ name: index, query: this.queryParam })
    }
  }
}
</script>

<style lang="scss">

</style>
